import { cva } from 'class-variance-authority';

export const inputVariants = cva(
  [
    'text-sm h-10 w-full min-w-0 rounded-lg border px-4 py-2',
    'transition-[color,box-shadow] outline-none',
    'disabled:pointer-events-none disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-300',
    'placeholder:text-gray-400 focus-visible:bg-gray-100 leading-4 placeholder-shown:bg-gray-100 placeholder-shown:border-teal-300',
    'data-has-left-icon:pl-10 data-has-right-icon:pr-10',
  ],
  {
    variants: {
      variant: {
        filled: 'border-teal-500 bg-mint-100 text-denim-800',
        invalid:
          'border-red-400 bg-red-100 placeholder-shown:bg-red-100 placeholder-shown:border-red-400',
      },
    },
    defaultVariants: {
      variant: 'filled',
    },
  }
);
